import React, { Component } from "react";
import "./shortVideoActivity.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class shortVideoActivity extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            selectImageId : '',
            userId : "",
            showBigImage : false,
            localAccountData :[
                {tagId : "douyin",account : ""},
                {tagId : "kuaishou",account : ""},
                {tagId : "xhs",account : ""},
                {tagId : "wechat",account : ""},
                {tagId : "weibo",account : ""},
                {tagId : "toutiao",account : ""},
                {tagId : "bili",account : ""},
            ],
            dataList :[
                {
                    title_p : "",
                    tagId : "",
                    example_img : "",
                    placeholder : "",
                    objectDict : {
                        imageUrl : "",
                        statusValue: "",
                        statusName : "",
                        result : "",
                        platform : "",
                    },
                    input_title:"",
                    activityAward : '',
                    account : "",
                },
            ],   
        };
    }

     getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    addShiliImage = (imageId) =>{//查看示例图

        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === imageId) {
                this.setState({
                    showBigImage : true,
                    bigImage : element.example_img,
                });
                return;
            }  
        
        }
    };

    addImage =(imageId) =>{//上传图片和查看大图

        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === imageId && element.objectDict.imageUrl.length) {
                this.setState({
                    showBigImage : true,
                    bigImage : element.objectDict.imageUrl,
                });
                return;
            }  
        }

        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativePhotoImage.postMessage('1');
                } catch (e) {
                }
            }else{
                try {
                    window.app.androidNativePhotoImage(1);
                } catch (e) {
                }
            }
        }

        this.setState({
            selectImageId : imageId,
        });
    };

    IOSPhotoImageUpload = (val) => {//图片回调

        let imageUrl = "";
        if (isiOS) {
            JSON.parse(val).map((item, key) => {
                imageUrl = item;
            });
        } else {
            val.split(",").map((item, key) => {
                imageUrl = item;
            });
        }

        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === this.state.selectImageId) {
                element.objectDict.imageUrl = imageUrl;
            }  
        }
        this.setState({
            dataList : dataList,
        });
    };

    closeBigImage =() =>{
        this.setState({
            showBigImage : false,
            bigImage : "",
        });
    };

    removeImage =(imageId) =>{
        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === imageId) {
                element.objectDict.imageUrl = "";
            }  
        }
        this.setState({
            dataList : dataList,
        });
    };

    loadingRequestdata = () =>{
        var i = 0;
        var dataArray = [];
        let dataList = this.state.dataList;

        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.objectDict.imageUrl.length && !element.objectDict.statusValue.length) {
                if (!element.account.length) {
                     Toast.show("请填写" + element.input_title, 2);
                    return;
                }
                dataArray.push({platform : element.tagId, imageUrl : element.objectDict.imageUrl, account : element.account});
            }
        }
        
        if (!dataArray.length) {
            Toast.show("请选择要上传的短视频截图", 2);
            return;
        }

       let dataJsonArray = JSON.stringify(dataArray);
        const _this = this;
        axios
         .post("fbusiness/json/saveShareActivityInfo",{userId : _this.state.userId, dataJson : dataJsonArray})
         .then(function (response){
            if (response.data.code === 10000) {
                  Toast.show("提交成功", 2);
                  _this.addSaveLocalAccount(dataArray);
                  setTimeout(() => {
                    _this.goToBack();
                }, 1500);
            }else {
               let message = response.data.message;
               Toast.show(message, 2);
            }  
         })
         .catch(function (error) {
            console.log(error);
         });

    };

    goToBack = () =>{
        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativeGotoBack.postMessage("");
                } catch (e) {
                }
            }else{
                try {
                    window.app.androidNativeGotoBack();
                } catch (e) {
                }
            }
        } 
    };

    componentDidMount (){

        sessionStorage.setItem("Authorization", this.getUrlParam('tokenHead') + ' ' + this.getUrlParam('tokenCode'));
        sessionStorage.setItem("cAppVersion", this.getUrlParam('v'));
        let userId = this.getUrlParam('userId');
        this.setState({
            userId : userId,
        });
         // funcitonName 是原生回调使用的方法名
        window["IOSPhotoImageUpload"] = this.IOSPhotoImageUpload.bind(this);
        //提取本地保存的数据
        this.addExtractLocalAccount();
        const _this = this;
        axios
         .post("fbusiness/json/getParticipateShareInfo",{userId : userId})
         .then(function (response){
            if (response.data.code === 10000) {
                let resultList = response.data.resultList;
                let notDataList = [];
                let haveDataList = [];
                if (resultList.length) {

                    for (let k = 0; k < resultList.length; k++) {
                        const element = resultList[k];
                        let normalDict = {
                            title_p : element.platformName + '内容截图',
                            tagId : element.platform,
                            example_img : element.sampleUrl,
                            activityAward : element.activityAward,
                            input_title : '账号(不是昵称)',
                            placeholder : '请输入' + element.platformName + '账号',
                            objectDict : {
                                imageUrl : "",
                                statusValue: "",
                                statusName : "",
                                result : "",
                                platform : "",
                            },
                            account : "",
                        };
            
                        if (element.statusValue.length > 0) {
                            normalDict.objectDict = element;
                            haveDataList.push(normalDict);
                        }else{
                            notDataList.push(normalDict);
                        }
                    }

                    if (haveDataList.length) {
                       for (let i = 0; i < haveDataList.length; i++) {
                        const element = haveDataList[i];
                        notDataList.push(element);
                       }
                    }

                    _this.setState({
                        dataList : notDataList,
                    });
                }
            }else {
               let message = response.data.message;
               Toast.show(message, 2);
            }  
         })
         .catch(function (error) {
            console.log(error);
         });
    }

    inputAccounts = (ev) => {
        var value = ev.target.value;
        if (value.length) {
            if (value.length > 15) {
                Toast.show("最多只能输入15个", 2);
                return;
            }
        }
        let dataList = this.state.dataList;
        for (let i = 0; i < dataList.length; i++) {
            const element = dataList[i];
            if (element.tagId === ev.target.id) {
                element.account = value;
            }
        }
        this.setState({
            dataList : dataList,
        })
        
    };

    render() {
        return (
            <div className="shortVideoActivity_div">
                {this.state.showBigImage ? (
                    <div className="showBigimage_div" onClick={() => this.closeBigImage()}>
                        <img className="showBigImage_img" src={this.state.bigImage}></img>
                    </div>
                ) : null}
                 <header className="header">
                    <img src = "http://image.ybk008.com/shortVideoActivityHeaderImg.png" />
                </header>
                <main>
                    <div className="shortVideoContent_div">

                        {this.state.dataList.map((item, key) =>(

                            <div className="content_background_div" key={key}>
                                <div className="titleContent_div">
                                    <div className="title_div">
                                        <p className="title_p">{item.title_p}</p>
                                        <p className="activityAward_p">{item.activityAward}</p>
                                    </div>
                                    <p className={item.objectDict.statusValue  === 'RFE' ? "status_p status_p_red" : (item.objectDict.statusValue  === 'APRE' ? "status_p status_p_greed" : "status_p")}>{item.objectDict.statusName}</p>
                                </div>
                                
                                <div className="shortVideoImg_div">
                                    <div className="addScreenshotphoto_div">
                                        <img className="addScreenshot_img" src={item.objectDict.imageUrl.length > 0 ? (item.objectDict.imageUrl) : require("../assets/imagepicker.png")} onClick={() =>this.addImage(item.tagId)}/>
                                        {item.objectDict.statusValue.length >0 ? null : item.objectDict.imageUrl.length > 0 ? (<img className="delete_img" src={require("../assets/icon-delete.png")} onClick={() =>this.removeImage(item.tagId)}/>) : null}
                                    </div>
                                    <p>示例图：</p>
                                    <img className="example_img" src={item.example_img} onClick={() =>this.addShiliImage(item.tagId)}/>
                                </div>

                                {item.objectDict.statusValue.length >0  ? 
                                    <div className="input_div">
                                        {item.objectDict.result.length > 0 ? (<p  className="input_p">提示：<span className="status_span" >{item.objectDict.result}</span></p>): null}
                                    </div>
                                :
                                    <div className="input_div">
                                        <p className="input_p">{item.input_title}:</p>
                                        <input id={item.tagId} className="number_input" placeholder={item.placeholder} onChange={(ev) => this.inputAccounts(ev)} value={item.account}/>
                                    </div>
                                }
                            </div>

                        ))}

                    </div>
                </main>
                <div className="seat_div" ></div>
                <button className="confirm_button" onClick={() =>this.loadingRequestdata()}>确认提交</button>

           </div>
        );   
    };

    addSaveLocalAccount = (dataArray) =>{
        let localAccountData = this.state.localAccountData;
        if (localStorage.getItem("localAccountData")) {
            localAccountData = JSON.parse(localStorage.getItem("localAccountData"));
        }
        if (dataArray.length) {
            for (let i = 0; i < dataArray.length; i++) {
                const element = dataArray[i];
                for (let j = 0; j < localAccountData.length; j++) {
                    const localelement = localAccountData[j];
                    if (element.platform === localelement.tagId) {
                        localelement.account = element.account;
                    }
                }
            }
        }

        localStorage.setItem('localAccountData', JSON.stringify(localAccountData));
    };

    addExtractLocalAccount = () =>{
        //提取本地保存的账号数据
        if (localStorage.getItem("localAccountData")) {
            let localAccountData = JSON.parse(localStorage.getItem("localAccountData"));
            let dataList = this.state.dataList;
            for (let i = 0; i < localAccountData.length; i++) {
                const localelement = localAccountData[i];
                for (let j = 0; j < dataList.length; j++) {
                    const element = dataList[j];
                    if (localelement.tagId === element.tagId) {
                        element.account = localelement.account;
                    }
                }   
            }
            this.setState({
                dataList : dataList
            });
        }
    };

}

export default shortVideoActivity;